import { Link } from "react-router-dom";
import { Flame, Heart, Leaf, Sparkles, ArrowRight } from "lucide-react";

export default function About() {
  return (
    <div data-testid="about-page">
      <section className="border-b border-[#E3DCD2] bg-[#F3EFEA]/40">
        <div className="max-w-7xl mx-auto px-6 lg:px-10 py-24">
          <div className="text-[11px] uppercase tracking-widest-plus text-[#D27D60] mb-4">✦ Our story</div>
          <h1 className="font-serif-display text-6xl md:text-7xl leading-[0.95] max-w-3xl">
            A small studio in <em className="text-[#D27D60]">Howrah</em>, pouring quiet joy into wax.
          </h1>
        </div>
      </section>

      <section className="max-w-7xl mx-auto px-6 lg:px-10 py-24 grid md:grid-cols-12 gap-12">
        <div className="md:col-span-5">
          <div className="aspect-[4/5] rounded-lg overflow-hidden bg-[#F3EFEA] hover-lift-img">
            <img
              src="https://images.pexels.com/photos/7233953/pexels-photo-7233953.jpeg"
              alt="Hands crafting candles"
              className="w-full h-full object-cover"
            />
          </div>
        </div>
        <div className="md:col-span-7 space-y-6">
          <div className="text-[11px] uppercase tracking-widest-plus text-[#D27D60]">✦ The philosophy</div>
          <h2 className="font-serif-display text-4xl md:text-5xl leading-tight">
            Hand-poured with love. Made to brighten your home — and your heart.
          </h2>
          <p className="text-base text-[#4a4a4a] leading-relaxed">
            Every candle at Ave_luxe is thoughtfully crafted using premium ingredients, beautiful fragrances and artistic designs. From charming decorative pieces to delightful scented candles, our studio in Mourigram, Howrah is a small, patient place — where wax is warmed slowly and wicks are trimmed by hand.
          </p>
          <p className="text-base text-[#4a4a4a] leading-relaxed">
            We also cast plaster figurines — princesses, mermaids and characters made for painting, gifting and imagining. Our DIY kits are designed for kids, hobbyists and creators who love the meditative act of making something with their hands.
          </p>
          <div className="pt-4">
            <Link
              to="/shop"
              className="inline-flex items-center gap-3 text-sm uppercase tracking-widest-plus underline underline-offset-8 hover:text-[#D27D60] transition-colors decoration-[#D27D60]/40"
              data-testid="about-shop-btn"
            >
              Shop the collection
              <ArrowRight className="w-4 h-4" strokeWidth={1.5} />
            </Link>
          </div>
        </div>
      </section>

      <section className="max-w-7xl mx-auto px-6 lg:px-10 py-16 grid md:grid-cols-4 gap-8">
        {[
          { icon: Flame, title: "Hand-poured", desc: "Every candle finished by hand in small batches." },
          { icon: Leaf, title: "Clean-burning", desc: "Premium soy & palm wax blends, cotton wicks." },
          { icon: Heart, title: "Made with love", desc: "In our Mourigram, Howrah studio." },
          { icon: Sparkles, title: "Gift-ready", desc: "Wrapped, ribbon-tied and thoughtful." },
        ].map((v, i) => (
          <div key={i} className="p-8 rounded-lg bg-[#F3EFEA]/60 border border-[#E3DCD2]">
            <v.icon className="w-6 h-6 text-[#D27D60] mb-4" strokeWidth={1.5} />
            <div className="font-serif-display text-2xl mb-2">{v.title}</div>
            <div className="text-sm text-[#4a4a4a] leading-relaxed">{v.desc}</div>
          </div>
        ))}
      </section>

      <section className="bg-[#1A1A1A] text-[#FDFBF7] py-24">
        <div className="max-w-4xl mx-auto px-6 lg:px-10 text-center">
          <div className="text-[11px] uppercase tracking-widest-plus text-[#9BA595] mb-6">✦ Visit us</div>
          <h2 className="font-serif-display text-4xl md:text-5xl leading-tight mb-6">
            Mourigram, Howrah — West Bengal 711109
          </h2>
          <p className="text-[#9BA595] mb-8">Open now · Closes 5pm</p>
          <Link
            to="/contact"
            className="inline-flex items-center gap-3 bg-[#D27D60] text-[#FDFBF7] px-7 py-3.5 rounded-full text-sm uppercase tracking-widest-plus hover:bg-[#c46e51] transition-colors"
            data-testid="about-contact-btn"
          >
            Get in touch
            <ArrowRight className="w-4 h-4" strokeWidth={1.5} />
          </Link>
        </div>
      </section>
    </div>
  );
}
